import classNames from 'classnames';
import type { JSX } from 'react';
import { useIntl } from 'react-intl';
import Typography from '@alltrails/core/components/Typography';
import Filter from '@alltrails/denali/icons/Filter';
import styles from './FilterButton.module.scss';

type FilterButtonProps = {
  filterCount: number;
  onClick: () => void;
};

/**
 * https://www.figma.com/file/rs0NObyE3shwzgNCuOljkC/Trail-details-Page-Redesign-%5BHandoff%5D?type=design&node-id=10801%3A107147&mode=dev
 */
const FilterButton = ({ filterCount, onClick }: FilterButtonProps): JSX.Element => {
  const intl = useIntl();
  const onClickInternal = () => {
    onClick();
  };

  return (
    <button
      aria-label={
        filterCount
          ? intl.formatMessage({ defaultMessage: '{count} filters applied. Select filters.' }, { count: filterCount })
          : intl.formatMessage({ defaultMessage: 'Select filters' })
      }
      className={classNames(styles.filterButton, { [styles.filtersApplied]: filterCount > 0 })}
      onClick={onClickInternal}
      type="button"
    >
      {filterCount > 0 ? (
        <>
          <Typography className={styles.filterCount} variant="text100bold">
            {filterCount}
          </Typography>
          <Filter size="xs" />
        </>
      ) : (
        <Filter size="xs" />
      )}
    </button>
  );
};

export default FilterButton;
